import { createSelector } from 'reselect';
import { RootState } from '../../store/store';

const userStateSelector = (state: RootState) => state.user;

export const selectUserData = createSelector(userStateSelector, user => user.data);

export const selectUserLoading = createSelector(userStateSelector, user => user.loading);

export const selectUserError = createSelector(userStateSelector, user => user.error || '');

export const selectUserFirstName = createSelector(selectUserData, data =>
  data ? data.firstName : '',
);

export const selectUserLastName = createSelector(selectUserData, data =>
  data ? data.lastName : '',
);

export const selectUserPhone = createSelector(selectUserData, data => (data ? data.phone : ''));

export const selectUserEmail = createSelector(selectUserData, data => (data ? data.email : ''));

export const selectUserIsActive = createSelector(selectUserData, data =>
  data ? data.isActive : false,
);

export const selectUserPk = createSelector(selectUserData, data => (data ? data.pk : ''));
